import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import BudgetTable from "../../BudgetTable";

import Slider from "./Slider";
import MediaQuery from "react-responsive";
const budget = {
  header: [
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
    "2023-2024",
  ],
  rows: {
    row1: [
      "Satellite Data",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row2: [
      "Field Experimentation & OutSoursing Activities",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row3: [
      "NRSC Manpower",
      "2.1",
      "1.9",
      "2.1",
      "2.3",
      "2.5",
      "2.7",
      "3.0",
      "3.3",
      "19.9",
    ],
    row4: [
      "Project Scientists",
      "",
      "23.9",
      "23.9",
      "23.9",
      "23.9",
      "23.9",
      "23.9",
      "23.9",
      "167.2",
    ],
    row5: [
      "Data Analysis",
      "2.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "30.0",
    ],
    row6: [
      "Hardware & Software + Maintenance",
      "15.0",
      "17.0",
      "1.0",
      "3.2",
      "3.2",
      "3.2",
      "3.2",
      "3.2",
      "49.2",
    ],
    row7: [
      "ALT DEM / High Resolution Satellite DEM Generation",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row8: [
      "Travel & Field Works",
      "1.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "29.0",
    ],
    row9: [
      "Training & Workshops",
      "0.0",
      "2.0",
      "12.0",
      "12.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "34.0",
    ],
    row10: [
      "Sub - Total 1",
      "20.1",
      "52.8",
      "46.9",
      "49.4",
      "39.6",
      "39.9",
      "40.1",
      "40.4",
      "329.3",
    ],
    row11: [
      "Project Management @ 5% of Sub - Total 1",
      "1.0",
      "2.6",
      "2.3",
      "2.5",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "16.5",
    ],
    row12: [
      "Sub - Total 2",
      "21.1",
      "55.4",
      "49.3",
      "51.9",
      "41.6",
      "41.9",
      "42.1",
      "42.5",
      "345.8",
    ],
    row13: [
      "Organization Overheads @ 5% of Sub - Total 2",
      "1.1",
      "2.8",
      "2.5",
      "2.6",
      "2.1",
      "2.1",
      "2.1",
      "2.1",
      "17.3",
    ],
    row14: [
      "Grand Total",
      "22.2",
      "58.2",
      "51.8",
      "54.5",
      "43.7",
      "44.0",
      "44.3",
      "44.6",
      "363.0",
    ],
  },
};
export default class FLFinancialProposal extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
          height: "800px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />

          <div className="card" style={{ flexGrow: "1", overflowX: "auto" }}>
            <MediaQuery minWidth={991}>
              <div
                className="card-body"
                style={{ margin: "auto", padding: "10px" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Development of Spatial Snowmelt Runoff product in the Indian
                  Himalayas
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <div className="card-body" style={{ padding: "10px" }}>
                <h3 align="center" style={{ color: "#002171" }}>
                  Development of Spatial Snowmelt Runoff product in the Indian
                  Himalayas
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
